import React from "react";
import "./index.css";
import cn from "classnames";
import {useSetting} from "../../../contexts/setting";
import {useBgUrl} from "hooks/useBgUrl";
import {useEdits} from "../../../contexts/edits";
import Textarea from "../../../layout/Textarea/Textarea";
import ContentEditable from "../../../layout/ContentEditable/ContentEditable";
import BgTransformer from "../../../layout/BgTransformer";
import ImageUpload from "../../../layout/ImageUpload";
import PixelationLayer from "../../../layout/PixelationLayer";
import {useLogoUrl} from "../../../hooks/useLogoUrl";

const Splash = ({id, zoom}) => {
  const {product, type, channel, layoutOption} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const edits = useEdits();
  const {productNames} = edits;
  const logoURL = useLogoUrl(id);
  const defaultProductName = product.altLabel || product.label;
  const productName = productNames[id] || productNames.main || defaultProductName;
  const subtitle = edits.subtitles?.[id] ?? edits.subtitles?.main;
  const templateClass = cn("template", `layout-${layoutOption}`, product.value);

  return (
    <>
      <div id={id} className={templateClass} style={{"--zoom-level": zoom}}>
        <div>
          <BgTransformer src={bgUrl} id={id} />
          <PixelationLayer />

          <div className="content">
            <div className="product-name">
              <ContentEditable id={id} text={productName} />
            </div>

            <div className="title-wrap">
              <div className="subtitle">
                <Textarea id={id} text={subtitle} />
              </div>
            </div>

            <header className="template-header">
              <div className="logo">
                <img src={logoURL} alt="background" />
              </div>
            </header>
          </div>
          {[5, 6].includes(+layoutOption) && (
            <div className="upload-wrap">
              <ImageUpload id={id} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Splash;
